import styled from 'styled-components/macro';
import { helperText } from 'styles/base-classes';

const DataWarning = styled('p')<any>`
  ${helperText};
  ${({ newDesign }): string =>
    newDesign
      ? `
    font-size: 11px;
  `
      : ''}
`;

/** @component */
export default DataWarning;
